module.exports = __webpack_public_path__ + "img/green-square-table-4.21201124.png";